import { render, staticRenderFns } from "./HoverBox.vue?vue&type=template&id=63669a58&scoped=true&"
import script from "./HoverBox.vue?vue&type=script&lang=js&"
export * from "./HoverBox.vue?vue&type=script&lang=js&"
import style0 from "./HoverBox.vue?vue&type=style&index=0&id=63669a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63669a58",
  null
  
)

export default component.exports